import React from "react";
import { Form, OverlayTrigger, Tooltip, Badge, Dropdown } from "react-bootstrap";
import Resume from "../../resume";
import { EductionCell, SkillsCell } from "../../student-profile/student-grid-view";
import { FileCheck2 } from "lucide-react";
import { maskStatus } from "../../../utils/maskContactInfo";
import { showStatusMsg } from "../../../utils/utils";

const StudentApplicationTable = ({
  student,
  selectedStudents,
  toggleStudentSelection,
  selectAllStudents,
  DisabledMessage,
  isDisabled,
  confirmStatusChange,
  confirmStatusToHired,
  openHistoryModal,
  getStatusBadgeVariant,
}) => {
  return (
    <tr>
      <td style={{ position: "relative" }}>
        {(student.status === "accept" || student.status === "hired" || student.status === "offer_accept" || student.status === "offer_declined" || student.status === "cancelled") ? (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-${student.id}`}>{DisabledMessage(student.status)}</Tooltip>
            }
          >
            <span className="d-inline-block">
              <Form.Check
                type="checkbox"
                className="rounded-circle"
                checked={selectedStudents.has(student.id)}
                onChange={() => toggleStudentSelection(student.id)}
                disabled={student.status === "accept" || student.status === "hired"}
              />
            </span>
          </OverlayTrigger>
        ) : (
          <span className="d-inline-block">
            <Form.Check
              type="checkbox"
              className="rounded-circle"
              checked={selectedStudents.has(student.id)}
              onChange={() => toggleStudentSelection(student.id)}
              disabled={student.status === "accept" || student.status === "hired"}
            />
          </span>
        )}
      </td>

      <td>
        <div className="d-flex align-items-center">
          <div>
            <div style={{ fontSize: "13px" }} className="fw-semibold">{student.name}</div>
            <i className="bi bi-geo-alt"></i> <small className="text-muted me-1"> {student.location}</small>
          </div>
        </div>
      </td>

      <td>
        <div style={{ fontSize: "14px" }} className="fw-medium">{student.position}</div>
      </td>

      <td>
        <div style={{ fontSize: "14px" }}>
          <div className="mb-1">
            <small>
              {maskStatus.includes(student.status) ? student.email : student.email}
            </small>
          </div>
          <div>
            <small>
              {maskStatus.includes(student.status) ? student.phone : student.phone}
            </small>
          </div>
        </div>
      </td>

      <td>
        <div className="d-flex flex-wrap gap-1">
          <EductionCell eductionList={student.degreeTitle} numShow={1} studentEdu={student?.eduArr || []} />
        </div>
      </td>

      <td>
        <div className="d-flex flex-wrap gap-1">
          <SkillsCell skillsCsv={student.skills} numShow={1} isApp />
        </div>
      </td>

      <td>
        <Badge
          bg={
            getStatusBadgeVariant(student.status)?.startsWith("custom")
              ? undefined
              : getStatusBadgeVariant(student.status)
          }
          className={
            getStatusBadgeVariant(student.status)?.startsWith("custom")
              ? getStatusBadgeVariant(student.status)
              : ""
          }
        >
          {showStatusMsg[student.status?.toLowerCase()] ||
            (student.status
              ? student.status.charAt(0).toUpperCase() + student.status.slice(1)
              : "")}
        </Badge>
      </td>

      <td>
        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-10px" }}>
          <Resume isStidentList id={student.student_id} isManualOpen />
          <Dropdown align="end">
            <Dropdown.Toggle
              as="button"
              className="btn btn-link text-dark p-0 no-caret"
            >
              <i className="ri-more-2-fill" style={{ fontSize: 20 }} />
            </Dropdown.Toggle>

            <Dropdown.Menu>

              {student.status !== "pending" && (
                <Dropdown.Item
                  disabled={isDisabled(student.status, "pending")}
                  className={`text-info ${
                    isDisabled(student.status, "pending")
                      ? "text-decoration-line-through"
                      : ""
                  }`}
                  onClick={() =>
                    !isDisabled(student.status, "pending") &&
                    confirmStatusChange(student.id, "pending", student)
                  }
                >
                  <i className="bi bi-eye me-1" /> Pending
                </Dropdown.Item>
              )}

              {student.status !== "accept" && (
                <Dropdown.Item
                  disabled={isDisabled(student.status, "accept")}
                  className={`text-success ${
                    isDisabled(student.status, "accept")
                      ? "text-decoration-line-through"
                      : ""
                  }`}
                  onClick={() =>
                    !isDisabled(student.status, "accept") &&
                    confirmStatusChange(student.id, "accept", student)
                  }
                >
                  <i className="bi bi-check-circle me-1" /> Shortlisted
                </Dropdown.Item>
              )}

              {student.status !== "hired" && (
                <Dropdown.Item
                  disabled={isDisabled(student.status, "hired")}
                  className={`text-success ${
                    isDisabled(student.status, "hired")
                      ? "text-decoration-line-through"
                      : ""
                  }`}
                  onClick={() =>
                    !isDisabled(student.status, "hired") &&
                    confirmStatusChange(student.id, "hired", student)
                  }
                >
                  <i className="bi bi-person-check me-1" /> Hired
                </Dropdown.Item>
              )}

              {student.status === "hired" && (
                <Dropdown.Item
                  className="text-success"
                  onClick={() =>
                    confirmStatusToHired(student.id, "hired", student)
                  }
                >
                  <FileCheck2 size={15} className="me-1" />
                  Send Offer Letter
                </Dropdown.Item>
              )}

              {student.status !== "rejected" && (
                <Dropdown.Item
                  disabled={isDisabled(student.status, "rejected")}
                  className={`text-danger ${
                    isDisabled(student.status, "rejected")
                      ? "text-decoration-line-through"
                      : ""
                  }`}
                  onClick={() =>
                    !isDisabled(student.status, "rejected") &&
                    confirmStatusChange(student.id, "rejected", student)
                  }
                >
                  <i className="bi bi-x-circle me-1" /> Rejected
                </Dropdown.Item>
              )}

              <Dropdown.Divider />

              <Dropdown.Item
                className="bg-primary text-light"
                onClick={() => openHistoryModal(student)}
              >
                <i className="bi bi-clock-history me-1" /> View History
              </Dropdown.Item>

            </Dropdown.Menu>
          </Dropdown>
        </div>
      </td>
    </tr>
  );
};

export default StudentApplicationTable;
